import { render, staticRenderFns } from "./BaseSpinner.vue?vue&type=template&id=a2865f98&scoped=true&"
import script from "./BaseSpinner.vue?vue&type=script&lang=ts&"
export * from "./BaseSpinner.vue?vue&type=script&lang=ts&"
import style0 from "./BaseSpinner.vue?vue&type=style&index=0&id=a2865f98&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2865f98",
  null
  
)

export default component.exports